import { ClipboardCheck } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { QuestionnairesPage } from './pages/QuestionnairesPage'
import { QuestionnaireDetailPage } from './pages/QuestionnaireDetailPage'
import { AnswerLibraryPage } from './pages/AnswerLibraryPage'

/**
 * Customer Questionnaires (2026-10-23).
 *
 * The log of vendor audit / supplier questionnaires customers send SPI.
 * Each upload is read by Claude, answered from the approved answer library,
 * and whatever the library can't answer is flagged for the regulatory team.
 * Approving writes the answers back to the library and builds the SPI
 * response PDF. Answered questionnaires can be imported to seed the
 * library. Anyone who receives questionnaires can log one; answering and
 * the library are admin + regulatory (enforced server-side).
 */
export default defineModule({
  id: 'questionnaires',
  name: 'Customer Questionnaires',
  shortName: 'Questionnaires',
  icon: ClipboardCheck,
  navSection: 'regulatory',
  navOrder: 12,
  urlNamespace: '/regulatory/questionnaires',
  routes: [
    { path: '/', element: QuestionnairesPage, label: 'Customer Questionnaires' },
    { path: '/library', element: AnswerLibraryPage, label: 'Answer Library' },
    { path: '/$questionnaireId', element: QuestionnaireDetailPage, label: 'Questionnaire' },
  ],
  permissions: [
    'admin',
    'regulatory',
    'sales',
    'inside_sales_rep',
    'operations',
    'operations_logistics',
    'purchasing',
  ],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',
  keyboardShortcut: 'g r q',
  commandPaletteEntries: [
    {
      label: 'Go to Customer Questionnaires',
      keywords: ['questionnaire', 'vendor audit', 'supplier survey', 'qualification', 'regulatory'],
      path: '/',
      group: 'modules',
      shortcut: 'g r q',
    },
    {
      label: 'Questionnaire Answer Library',
      keywords: ['questionnaire', 'answers', 'library', 'audit'],
      path: '/library',
      group: 'modules',
    },
  ],
})
